﻿import { IMilestoneTemplate } from "@/interfaces";

export const OFFSET_TO_INSERT_AFTER = 1;
const INDEX_NOT_FOUND = -1;

export const duplicateMilestone = (
  milestones: IMilestoneTemplate[],
  milestoneToDuplicate: IMilestoneTemplate,
  uuid: () => string
): IMilestoneTemplate[] => {
  const index = milestones.findIndex(
    ({ id }) => id === milestoneToDuplicate.id
  );

  if (index === INDEX_NOT_FOUND) {
    const milestonesWithoutReference = JSON.parse(JSON.stringify(milestones));
    return milestonesWithoutReference.map((milestone: IMilestoneTemplate) => {
      if (milestone.childMilestones) {
        milestone.childMilestones = duplicateMilestone(
          milestone.childMilestones,
          milestoneToDuplicate,
          uuid
        );
      }

      return milestone;
    });
  }

  const updatedMilestones = [...milestones];
  const milestoneToDuplicateWithoutReference = JSON.parse(
    JSON.stringify(milestoneToDuplicate)
  );
  const updatedMilestone = recursivelyUpdateMilestoneId(
    milestoneToDuplicateWithoutReference,
    uuid
  );

  updatedMilestones.splice(index + OFFSET_TO_INSERT_AFTER, 0, updatedMilestone);

  return updatedMilestones;
};

const recursivelyUpdateMilestoneId = (
  milestone: IMilestoneTemplate,
  uuid: () => string
): IMilestoneTemplate => {
  milestone.id = uuid();
  milestone.childMilestones = milestone.childMilestones?.map((milestone) =>
    recursivelyUpdateMilestoneId(milestone, uuid)
  );

  return milestone;
};
